var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileTypeCssIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.804 54.402L7.31201 4H56.688L52.19 54.394L31.97 60L11.804 54.402Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55.716L48.34 51.186L52.184 8.12195H32V55.716Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.382H40.18L40.744 20.052H32V13.87H32.022H47.5L47.352 15.528L45.834 32.564H32V26.382Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.038 42.4361L32.01 42.4441L25.126 40.5841L24.686 35.6541H21.34H18.48L19.346 45.3601L32.008 48.8761L32.038 48.8681V42.4361Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.654 32.302L38.91 40.58L32.016 42.44V48.872L44.688 45.36L44.782 44.316L45.856 32.302H39.654Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.022 13.87V17.71V20.036V20.052H17.11H17.09L16.966 18.662L16.684 15.528L16.536 13.87H32.022Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 26.382V30.222V32.548V32.564H25.222H25.202L25.078 31.174L24.798 28.04L24.65 26.382H32Z",
    fill: "#EBEBEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTypeCssIcon);
export default __webpack_public_path__ + "static/media/file_type_css_icon.628f5283b4593914daa522c18f4d7cbc.svg";
export { ForwardRef as ReactComponent };